import template from '../theme/festzelt-os/views/main.html';
import errorTemplate from '../theme/festzelt-os/views/error.html';

angular
    .module('festzelt-os.pages')
    .config([
        '$stateProvider',
        '$urlRouterProvider',
        config
    ]);


function config($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('app', {
            templateUrl: template,
            abstract: true,
            params: {
                sideView: false,
                back: undefined,
                backParams: undefined
            },
            data: {
                bodyClass: 'page-header-fixed',
                collapsedSidebarOnLoad: false,
                fullWidth: false,
                hideBreadcrumb: false
            },
            resolve: {
                loginRequired: [
                    '$q',
                    '$location',
                    '$auth',
                    loginRequired
                ]
            }
        })
        .state('error', {
            url: '/oops',
            params: {skipRetry: false},
            data: {
                pageTitle: 'Oops. An error has occurred'
            },
            templateUrl: errorTemplate,
        });

    $urlRouterProvider.otherwise('/dashboard');

    function loginRequired($q, $location, $auth) {
        return $q.when($auth.isAuthenticated()).then(function (result) {
            if (result) {
                return $auth.getUser().then((user) => {
                    if (_.get(user, 'settings.billing.is_pos_user', false)) {
                        $location.path('pos/');
                    } else {
                        return true;
                    }
                }, () => {
                    return true;
                });
            } else {
                $location.path('auth/login');
            }
        }, function () {
            $location.path('auth/login');
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/pages-routes.js